import { PaginatedQueryParams, usePaginatedQuery } from '@/hooks/use-paginated-query';
import { SelectInfiniteQueryParams, useSelectInfiniteQuery } from '@/hooks/use-select-infinite.query';
import UserData from '@/types/User/UserData';

type Params = PaginatedQueryParams;

export const useGetMentionUsersQuery = ({ dispatchPagination, ...params }: Params) => {
  return usePaginatedQuery<UserData>({
    queryKey: ['credit-request/mention/user', params],
    url: `credit-request/mention/user`,
    permissions: ['credit.request.mention.user.index'],
    params: {
      ...params,
      dispatchPagination,
    },
  });
};

export const useGetMentionUsersSelectQuery = (params: SelectInfiniteQueryParams) => {
  const query = useSelectInfiniteQuery<UserData>({
    url: 'credit-request/mention/user',
    queryKey: ['credit-request/mention/user', params],
    staleTime: 1000 * 60 * 5,
    permissions: ['credit.request.mention.user.index'],
    params,
  });

  return query;
};
